import classNames from 'classnames';
import { FC, memo, ReactNode } from 'react';

interface CardSectionProps {
  /** receives any element or string as a child  */
  children?: ReactNode;
  /** remove padding to section container */
  noPadding?: boolean;
  /** show the card section disabled */
  disabled?: boolean;
  /** extra class names */
  className?: string;
}

const CardSection: FC<CardSectionProps> = ({
  children,
  noPadding = false,
  disabled,
  className,
}): JSX.Element => {
  const classes = classNames(
    'eb-card-section',
    {
      'p-4': !noPadding,
      'opacity-50	': disabled,
    },
    className
  );

  return <div className={classes}>{children}</div>;
};

export default memo(CardSection);
